import { apiJson } from '@/lib/api';
import type { SelectedConversation } from '@/lib/types';

type GetToken = () => Promise<string | null>;

export type TempCheckResult = {
  level: 'cool' | 'warm' | 'hot';
  score: number;
  label: string;
  suggestion: string | null;
  context_size?: number;
};

export type TempCheckScope =
  | { kind: 'main' }
  | { kind: 'custom'; chat_room_id: number }
  | { kind: 'expense_dispute'; expense_dispute_id: number }
  | { kind: 'payment_dispute'; payment_dispute_id: number };

function scopeToBody(scope: TempCheckScope) {
  switch (scope.kind) {
    case 'main':
      return {
        chat_room_id: null,
        expense_dispute_id: null,
        payment_dispute_id: null,
      };
    case 'custom':
      return {
        chat_room_id: scope.chat_room_id,
        expense_dispute_id: null,
        payment_dispute_id: null,
      };
    case 'expense_dispute':
      return {
        chat_room_id: null,
        expense_dispute_id: scope.expense_dispute_id,
        payment_dispute_id: null,
      };
    case 'payment_dispute':
      return {
        chat_room_id: null,
        expense_dispute_id: null,
        payment_dispute_id: scope.payment_dispute_id,
      };
  }
}

export function conversationToTempCheckScope(
  conversation: SelectedConversation
): TempCheckScope {
  switch (conversation.type) {
    case 'main':
      return { kind: 'main' };
    case 'custom-chat':
      return { kind: 'custom', chat_room_id: conversation.chatId };
    case 'expense-dispute':
      return {
        kind: 'expense_dispute',
        expense_dispute_id: conversation.disputeId,
      };
    case 'payment-dispute':
      return {
        kind: 'payment_dispute',
        payment_dispute_id: conversation.disputeId,
      };
  }
}

export async function checkTempLevel(
  getToken: GetToken,
  content: string,
  scope: TempCheckScope,
  signal?: AbortSignal
): Promise<TempCheckResult> {
  return apiJson<TempCheckResult>(getToken, '/v1/tempcheck', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      content,
      ...scopeToBody(scope),
    }),
    signal,
  });
}
